import { makeStyles } from '@fluentui/react-components';
const colors = {
    background: `var(--colorNeutralBackground1,--ms-themeColorBodyBackground)`,
    foreground: `var(--colorNeutralForeground2,--ms-themeColorBodySubtext)`,
    brand: `var(--colorBrandForeground1,--ms-themeColorPaletteThemePrimary)`
};
export const useCopyAnimatedStyles = makeStyles({
    copyIcon: {
        '> svg': {
            '> rect': {
                strokeWidth: '2'
            }
        }
    },
    backgroundRect: {
        stroke: colors.foreground,
        fill: colors.foreground
    },
    backgroundRectOver: {
        stroke: colors.brand,
        fill: colors.brand,
        animationDuration: '250ms',
        animationFillMode: 'forwards',
        animationTimingFunction: `cubic-bezier(0.17, 0.17, 0.2, 1)`,
        animationName: {
            '100%': {
                scale: '0.85',
                transform: 'translate(-3px, 9px)'
            }
        }
    },
    backgroundRectOut: {
        animationDuration: '450ms',
        animationFillMode: 'forwards',
        animationTimingFunction: `cubic-bezier(0.17, 0.17, 0.67, 1)`,
        animationName: {
            '0%': {
                scale: 0.85,
                transform: 'translate(-3px, 9px)'
            },
            '30%': {
                scale: 1,
                transform: 'translate(1px, -1px)',
                animationTimingFunction: 'cubic-bezier(0.33, 0, 0.1, 1)'
            },
            '100%': {
                scale: 1,
                transform: 'translate(0px, 0px)'
            }
        }
    },
    outlineRect: {
        stroke: colors.background,
        fill: colors.background
    },
    outlineRectOver: {
        stroke: colors.background,
        fill: colors.background,
        animationDuration: '250ms',
        animationFillMode: 'forwards',
        animationTimingFunction: `cubic-bezier(0.17, 0.17, 0.2, 1)`,
        animationName: {
            '100%': {
                scale: '0.85',
                transform: 'translate(12px, -7px)'
            }
        }
    },
    outlineRectOut: {
        animationDuration: '450ms',
        animationFillMode: 'forwards',
        animationTimingFunction: `cubic-bezier(0.17, 0.17, 0.67, 1)`,
        animationName: {
            '0%': {
                scale: 0.85,
                transform: 'translate(12px, -7px)'
            },
            '30%': {
                scale: 1,
                transform: 'translate(1px, -1px)',
                animationTimingFunction: 'cubic-bezier(0.33, 0, 0.1, 1)'
            },
            '100%': {
                scale: 1,
                transform: 'translate(0px, 0px)'
            }
        }
    },
    frontRect: {
        fill: colors.background,
        stroke: colors.foreground,
        strokeLinecap: 'round',
        strokeDasharray: '9 4 6 4',
        strokeDashoffset: '15%'
    },
    frontRectOver: {
        stroke: colors.brand,
        fill: colors.brand,
        animationTimingFunction: `cubic-bezier(0.17, 0.17, 0.2, 1)`,
        strokeDasharray: '0',
        animationDuration: '250ms',
        animationFillMode: 'forwards',
        animationName: {
            '100%': {
                scale: 0.85,
                transform: 'translate(10px, -5px)'
            }
        }
    },
    frontRectOut: {
        animationTimingFunction: `cubic-bezier(0.17, 0.17, 0.2, 1)`,
        animationDuration: '450ms',
        animationFillMode: 'forwards',
        animationName: {
            '0%': {
                scale: 0.85,
                transform: 'translate(10px, -5px)'
            },
            '30%': {
                scale: 1,
                transform: 'translate(-1px, 1px)',
                animationTimingFunction: 'cubic-bezier(0.33, 0, 0.1, 1)'
            },
            '100%': {
                scale: 1,
                transform: 'translate(0px, 0px)'
            }
        }
    },
    dottedLine: {
        opacity: 0
    },
    dottedLineOver: {
        opacity: 1,
        transform: 'scale(1)',
        fill: 'none',
        stroke: colors.brand,
        strokeDashoffset: '0',
        strokeDasharray: '7.8 7',
        strokeLinecap: 'round',
        transformOrigin: 'center center',
        animationDuration: '250ms, 8s',
        animationTimingFunction: 'cubic-bezier(0.17, 0.17, 0.2, 1), linear',
        animationIterationCount: '1, infinite',
        animationDirection: ' normal',
        animationFillMode: ' forwards',
        scale: 0.7,
        animationName: [
            {
                '20%': {
                    opacity: 0,
                    scale: 0.7
                },
                '100%': {
                    opacity: 1,
                    scale: 1
                }
            },
            {
                '100%': {
                    strokeDashoffset: '96'
                }
            }
        ]
    }
});
